import styled from "styled-components"

import SelectInput from "components/select-input"
import { maxWidth } from "utils"

export const Container = styled.div`
  margin-bottom: 5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${maxWidth.desktop`
    align-items: flex-start;
    flex-direction: column;
  `}
`

export const Box = styled.div`
  display: flex;
  align-items: center;

  ${maxWidth.desktop`
    width: 100%;
    margin-top: 1.5rem;
    align-items: flex-start;
    flex-direction: column;
  `}
`

export const Title = styled.div`
  margin-right: 1rem;
  color: #767676;
  font-family: "Maax-Medium", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  text-transform: uppercase;
  line-height: 14px;
  letter-spacing: 0.5px;
`

export const Select = styled(SelectInput)`
  width: 170px;
  margin-left: 2rem;

  ${maxWidth.desktop`
    width: 50%;
    margin: 1rem 0 0;
  `}

  ${maxWidth.mobile`
    width: 100%;
  `}

  input[type="text"] {
    padding: 2.3rem 2.4rem;
    border: 0.2rem solid #c9c9c9;
    ${({ theme }) => theme.component.isDarkBackground && "border: 0;"}
    border-radius: 10rem;
    background: #fff;
    color: ${({ theme }) => theme.colors.text.primary};
    font-size: 1.7rem;
    font-weight: 500;
    letter-spacing: 0.003rem;
  }
`
